import React from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from '@/ui';
import { QuestionnaireList, Questionnaire } from '@/features/constructor';
import { Typography } from 'antd';

export const Constructor = () => {
  const { t } = useTranslation();

  return (
    <Container $paddingY={20}>
      <Container $marginBottom={30}>
        <Typography.Title level={3}>{t('Constructor questionnaires')}</Typography.Title>
      </Container>

      <QuestionnaireList />
      <Questionnaire />
    </Container>
  );
};
